<div data-cy="app-root" class="h-100">
  <router-outlet></router-outlet>
</div>
